
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { PessoaService } from 'src/services/pessoa.service';


@Component({
    selector: 'app-pessoa-form',
    templateUrl: './pessoa-form.component.html',
    styleUrls: ['./pessoa-form.component.scss'],
    standalone: false
})
export class PessoaFormComponent implements OnInit {
  
  mascara: any;

  existe_contato_principal: boolean = false
  existe_endereco_principal: boolean = false
  existe_administrador: boolean = false
  existe_presidente: boolean = false

  files: any = null
  images: any[] = []
  imagensSalvas: any[] = []

  desabilita_inserir_quadro_societario: boolean = false

  maximo_percentual: any

  processando: boolean = false

  tela_nova_pessoa: boolean = false
  tela_horario_funcionamento: boolean = false
  voltar_dashboard: boolean = false
  horario_salvo: boolean = false
  horario_limpo: boolean = false
  loading: boolean = false

  home = { icon: 'pi pi-home', routerLink: '/' };
  item: any = []
  rows: number = 10
  tituloPagina: any;


  cadastroIncial: any;

  form: FormGroup;
  cols_ass = [
    { field: 'caminho_imagem', header: 'Nome do arquivo' },
  ]

  cols_contato = [
    { field: 'tipo_contato', header: 'Tipo do Contato' },
    { field: 'contato', header: 'Contato' },
    { field: 'campo_principal', header: 'Contato principal' },
  ]

  cols_desconto = [
    { field: 'descricao', header: 'Categorias aplicáveis' },
    { field: 'descricao_tipo_desconto', header: 'Tipo desconto' },
    { field: 'valor', header: 'Desconto' },
  ]

  cols_quadro_societario = [
    { field: 'socio', header: 'Sócio' },
    { field: 'percentual', header: 'Percentual' },
    { field: 'administrador', header: 'Administrador' },
  ]

  cols_diretoria = [
    { field: 'pessoa_id', header: 'Diretor' },
    { field: 'presidente', header: 'Presidente' },
  ]

  cols_endereco = [
    { field: 'cep', header: 'CEP' },
    { field: 'logradouro', header: 'Logradouro' },
    { field: 'bairro', header: 'Bairro' },
    { field: 'numero', header: 'Numero' },
    { field: 'complemento', header: 'Complemento' },
    { field: 'municipio', header: 'Cidade' },
    { field: 'uf', header: 'UF' },
  ]


  array_contatos: any[] = [];
  array_enderecos: any[] = [];
  /** IDs de endereços excluídos na alteração (PUT): enviar em pessoa_endereco_excluir_ids */
  pessoa_endereco_excluir_ids: number[] = [];
  array_quadro_societario: any[] = [];
  array_assinaturas: any[] = [];
  array_diretoria: any[] = [];
  array_desconto: any[] = [];
  array_horario_funcionamento: any[] = [];
  array_horario_funcionamento_selecionado: any[] = [];

  arquivos: any[] = [];
  uploadedFiles: any[] = [];
  photos: any[] = [];

  pessoasFiltradas: any[] = [];

  dropDownTipDesconto: any[] = [
    { value: 0, label: 'Desconto normal' },
    { value: 1, label: 'Desconto especial' },
    { value: 2, label: 'Exceção desconto' },
  ]

  dropDownTipoArquivo: any[] = [
    { value: null, label: 'Selecione' },
  ]


  dropDownTipoPessoa: any[] = [
    { value: 0, label: 'Pessoa Física' },
    { value: 1, label: 'Pessoa Jurídica' },
  ]

  dropDownLojista: any[] = []
  dropDownCategoriaLojista: any[] = []
  dropDownCdl: any[] = []
  dropDownFuncao: any[] = []
  dropDownFormasPagamento: any[] = []

  gruposUsuario: any[] = []

  dropDownSexo: any[] = [
    { value: 0, label: 'Masculino' },
    { value: 1, label: 'Feminino' },
    
  ]

  dropDownTipoContato: any[] = [
    { value: 0, label: 'FACEBOOK', mascara: null },
    { value: 1, label: 'TELEFONE', mascara: '(99) 9999-9999' },
    { value: 2, label: 'CELULAR', mascara: '(99) 99999-9999' },
    { value: 3, label: 'E-MAIL', mascara: null },
    { value: 4, label: 'INSTAGRAM', mascara: null },
    { value: 5, label: 'SITE', mascara: null },
    { value: 6, label: 'TWITTER', mascara: null },
  ]

  pt = {
    firstDayOfWeek: 0,
    dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
    dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
    dayNamesMin: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sa'],
    monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho',
      'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    today: 'Hoje',
    clear: 'Limpar'
  };

  user = JSON.parse(localStorage.getItem('user') ?? '{}');

  options = {
    center: { lat: -15.601916957409683, lng: -56.09373344118861 },
    zoom: 12
  };

  dialogMap: boolean = false;
  dialogVisible: boolean;
  markerTitle: string;
  selectedPosition: any;
  overlays: any[] = [];
  infoWindow: any;
  marcacao: any = ''

  constructor(
    protected _formBuilder: FormBuilder,
    private _router: Router,
    private _route: ActivatedRoute,
    private http: HttpClient,
    private messageService: MessageService,
    protected _pessoaService: PessoaService,

  ) { }


  ngOnInit(): void {



    this.form = this._formBuilder.group({
      pessoa: this._formBuilder.group({
        id: [null],
        nome: [null, Validators.required],
        tipo: [null],
        ativo: [null],
        cliente: [null],
        fornecedor: [null],
        integrador: [null],
        celular_principal: [null],
        telefone_principal: [null],
        email_principal: [null],
        funcao_id: [null],
        observacao: [null],
      }),
      pessoa_fisica: this._formBuilder.group({
        cpf: [null],
        nascimento: [null],
        sexo: [null],
      }),
      pessoa_juridica: this._formBuilder.group({
        razao_social: [null],
        cnpj: [null],
      }),
      pessoa_contato: this._formBuilder.group({
        contato: [null],
        tipo_contato_id: [null],
        principal: [null],
        ativo: [null],
      }),
      pessoa_endereco: this._formBuilder.group({
        cep: [null],
        logradouro: [null],
        municipio: [null],
        complemento: [null],
        uf: [null],
        bairro: [null],
        principal: [null],
        numero: [null],
      }),
    })

    let url = window.location.href;

    if (url.includes('cliente-form')) {
      this.tituloPagina = 'Cliente';
      this.form.get('pessoa.cliente').setValue(true)
      this.form.get('pessoa.fornecedor').setValue(false)
      this.form.get('pessoa.integrador').setValue(false)
    } else if (url.includes('fornecedor-form')) {
      this.tituloPagina = 'Fornecedor';
      this.form.get('pessoa.tipo').setValue(1)
      this.form.get('pessoa.fornecedor').setValue(true)
      this.form.get('pessoa.cliente').setValue(false)
      this.form.get('pessoa.integrador').setValue(false)
    } else if (url.includes('integrador-form')) {
       this.tituloPagina = 'Integrador'
       this.form.get('pessoa.tipo').setValue(1)
       this.form.get('pessoa.integrador').setValue(true)
       this.form.get('pessoa.cliente').setValue(false)
       this.form.get('pessoa.fornecedor').setValue(false)
    } 

   

    this.listLojista()
    this.listCategoriaLojista()
    this.listFuncaoFuncionario()
    this.listCdl()
    this.listGrupos()

    if (this._route.snapshot.paramMap.get('id') !== 'null') {
      this.cadastroIncial = 'EDITAR'
      this.show(this._route.snapshot.paramMap.get('id'));

    } else {
      this.cadastroIncial = 'INICIO'
      this.openNew();
      if (url.includes('cliente-form')) {
        this.form.get('pessoa.tipo').setValue(0);
      }
    }


  }


  openNew() {
    this.array_enderecos = []
    this.form.get('pessoa.ativo').setValue(true)
    
  }

  listGrupos() {
    this.gruposUsuario = [];
    // this._grupoUsuarioService.index().subscribe(json => {
    //   json.map((item: any) => {
    //     this.gruposUsuario.push({ id: item.id, nome: item.nome });
    //   })
    // })
  }

  listCategoriaLojista() {
    this.dropDownCategoriaLojista = []
    // this._clService.index().subscribe(json => {

    //   json.map(item => {
    //     this.dropDownCategoriaLojista = [...this.dropDownCategoriaLojista, { value: item.id, label: item.descricao },];
    //   })
    // })
  }

  listFuncaoFuncionario() {
    this.dropDownFuncao = []
    // this._funcao.index().subscribe(json => {

    //   json.map(item => {
    //     if (item.ativo == true) {
    //       this.dropDownFuncao = [...this.dropDownFuncao, { value: item.id, label: item.descricao },];
    //     }
    //   })
    // })
  }

  listLojista() {
    this.dropDownLojista = []
    // this._pessoa.paginate('lojista=true').subscribe(json => {

    //   json.data.map(item => {
    //     this.dropDownLojista = [...this.dropDownLojista, { value: item.id, label: item.nome },];
    //   })
    // })
  }

  listCdl() {
    this.dropDownCdl = []
    // this._pessoa.paginate('cdl=true').subscribe(json => {

    //   json.data.map(item => {
    //     this.dropDownCdl = [...this.dropDownCdl, { value: item.id, label: item.nome },];
    //   })
    // })
  }

  show(event: any) {

    this.array_contatos = [];
    this.array_desconto = [];
    this.array_enderecos = [];
    this._pessoaService.show(event).subscribe({
      next: (json: any) => {
      // if (json.arquivos) {
      //   json.arquivos.map(item => {

      //     this.imagensSalvas.push({
      //       url: this.urlStorage + item.arquivo.path,
      //       tipo_arquivo: item.tipo_arquivo
      //     })
      //   })
      // }

      //--<remove o 55>--
      if (json.pessoa.celular_principal) {
        if (json.pessoa.celular_principal.length == 13) {
          json.pessoa.celular_principal = json.pessoa.celular_principal.substring(2);
        }
      }
      if (json.pessoa.telefone_principal) {
        if (json.pessoa.telefone_principal.length == 12) {
          json.pessoa.telefone_principal = json.pessoa.telefone_principal.substring(2);
        }
      }
     


      this.form.get('pessoa')?.patchValue(json.pessoa);

      const tipo = json.pessoa.tipo === 1 || json.pessoa.tipo === '1' ? 1 : 0;
      this.form.get('pessoa.tipo').setValue(tipo);

      if (json.pessoa.pessoa_fisica) {
        json.pessoa.pessoa_fisica.nascimento = moment.utc(json.pessoa.pessoa_fisica.nascimento).format('YYYY-MM-DD')
        this.form.get('pessoa_fisica').patchValue(json.pessoa.pessoa_fisica);
      }

      if (json.pessoa.pessoa_juridica) {
        this.form.get('pessoa_juridica').patchValue(json.pessoa.pessoa_juridica);
      }

      

      if (json.pessoa.pessoa_enderecos) {
        this.pessoa_endereco_excluir_ids = [];
        json.pessoa.pessoa_enderecos.map(element => {
          this.array_enderecos.push({
            id: element.id,
            cep: element.cep,
            logradouro: element.logradouro,
            complemento: element.complemento,
            numero: element.numero,
            bairro: element.bairro,
            municipio: element.municipio,
            uf: element.uf,
          })
        })

      }

      if (json.pessoa.pessoa_contato) {
        json.pessoa.pessoa_contato.map(element => {
          this.array_contatos.push({
            id: element.id,
            nome: element.nome,
            apelido: element.fisica.apelido,
            celular_principal: element.celular_principal,
            email_principal: element.email_principal
          })
        });
      }

    
      },
      error: (err) => {
        const msg = err?.error?.message || 'Não foi possível carregar o cliente.';
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: msg,
        });
      }
    });
  }

  novaPessoa() {
    this.form.get('nova_pessoa').reset()
    this.tela_nova_pessoa = true
  }

  saveNovaPessoa() {
    // let pessoa = this.form.get('nova_pessoa').value
    // let socio: any;

    // let params = {
    //   pessoa: {
    //     ativo: true,
    //     nome: pessoa.nome,
    //     email_principal: pessoa.email,
    //     funcionario: null,
    //     cliente: null,
    //     fornecedor: false,
    //     tipo: 'FISICA',
    //     celular_principal: pessoa.celular,
    //   },
    //   endereco: [],
    // }

    // this._pessoa.store(params, 'descontoLojista=true').subscribe(
    //   (json) => {
    //     socio = { value: json.id, label: json.nome };
    //     this.form.get("quadro_societario.pessoa_id").setValue(socio);
    //     this.tela_nova_pessoa = false;
    //   },
    //   (err) => { }
    // );
  }

  save() {
    this.loading = true
    let pessoa = this.form.get('pessoa').value
    let pessoa_fisica = this.form.get('pessoa_fisica').value
    let pessoa_juridica = this.form.get('pessoa_juridica').value

    const routeId = this._route.snapshot.paramMap.get('id');
    const pessoaId = pessoa?.id ?? (routeId && routeId !== 'null' ? Number(routeId) : null);

    if (!pessoa?.nome || !String(pessoa.nome).trim()) {
      this.loading = false;
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Informe o nome do cliente antes de salvar.',
      });
      return;
    }

    if (pessoaId && !pessoa.id) {
      pessoa = { ...pessoa, id: pessoaId };
      this.form.get('pessoa.id')?.setValue(pessoaId);
    }

    let params: any = {
      pessoa: pessoa,
      pessoa_fisica: pessoa_fisica,
      pessoa_juridica: pessoa_juridica,
      pessoa_contato_principal: {
       telefone: pessoa.telefone_principal,
        celular: pessoa.celular_principal,
        email: pessoa.email_principal,
        telefone_privado: null,
        celular_privado: null,
        email_privado: null
      },
      pessoa_endereco: this.array_enderecos,
      pessoa_contato: [],
    }

    if (pessoaId) {
      if (this.pessoa_endereco_excluir_ids.length > 0) {
        params = { ...params, pessoa_endereco_excluir_ids: this.pessoa_endereco_excluir_ids };
      }
      this._pessoaService.update(params, pessoaId).subscribe(json => {
        this.loading = false;
        this.cancel();
      }, err => {
        this.loading = false;
        const msg = err?.error?.message || 'Erro ao salvar registro';
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: msg,
        });
      });
    } else {
      this._pessoaService.store(params).subscribe(json => {
        //voltar para o list
       this.cancel()
      }, err => {
        this.loading = false
        const msg = err?.error?.message || 'Erro ao salvar registro';
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: msg,
        });
      })
    }
   

  }






  cancel() {
    let url = window.location.href;
    if (url.includes('cliente-form')) {
      this._router.navigate(['/cadastro/cliente-list']);
    } else if (url.includes('fornecedor-form')) {
      this._router.navigate(['/cadastro/fornecedor-list']);
    } else if (url.includes('integrador-form')) {
      this._router.navigate(['/cadastro/integrador-list']);
    } 

  }



  addArquivos(event: any) {
    // let fileRet = event.originalEvent.body;
    // fileRet.map((ass:any) => {
    //   this.arquivos.push({
    //     caminho_imagem: ass.caminho,
    //     name: ass.nome,
    //     url_imagem: this.urlStorage + "/" + ass.caminho
    //   })
    // })
  }



  removeDiretor(dir:any) {
  }

  removeSocio(soc:any) {
    let arr = this.array_quadro_societario.filter(x => { return x.pessoa_id !== soc.pessoa_id });

    this.array_quadro_societario = []

    this.array_quadro_societario = arr;
    this.verificaQuadroSocietario()
  }

  removeArquivo(arquivo:any) {
    let arr = this.arquivos.filter(x => { return x.name !== arquivo.name });

    this.arquivos = []

    this.arquivos = arr;
  }

  changeTipoContato() {
    let y = this.form.get('pessoa_contato.tipo_contato_id').value

    let c = this.dropDownTipoContato.filter(x => { return x.value == y });

    this.mascara = (c[0].mascara)
    // this.verificaContatoPrincipal()

  }

  // verificaContatoPrincipal() {
  //   let p = this.array_contatos.find(element => element.campo_principal == 'Sim')

  //   if (p == undefined) {
  //     this.existe_contato_principal = false
  //   } else {
  //     this.existe_contato_principal = true
  //   }

  // }

  verificaPresidente() {
    let p = this.array_diretoria.find(element => element.presidente == 'Sim')

    if (p == undefined) {
      this.existe_presidente = false
    } else {
      this.existe_presidente = true
    }

  }

  verificaQuadroSocietario() {
    let p = this.array_quadro_societario.find(element => element.administrador == 'Sim')
    
    if (p == undefined) {
      this.existe_administrador = false
    } else {
      this.existe_administrador = true
    }


    let soma: number = 0;
    this.array_quadro_societario.map(item => {
      item.percentual = Number.parseFloat(item.percentual);
      soma += item.percentual
    });


    this.maximo_percentual = 100 - soma;

    if (this.maximo_percentual == 0) {
      this.desabilita_inserir_quadro_societario = true;
    } else {
      this.desabilita_inserir_quadro_societario = false;
    }





  }

  horarioFuncionamento() {
    this.horario_limpo = false
    this.horario_salvo = false
    this.tela_horario_funcionamento = true
    this.array_horario_funcionamento = []
    if (this.array_horario_funcionamento_selecionado.length > 1) {
      this.array_horario_funcionamento = this.array_horario_funcionamento_selecionado
    } else {
      this.array_horario_funcionamento.push({
        dia_semana: 0,
        dia: 'DOMINGO',
        aberto: false,
        abertura: null,
        fechamento: null
      },
        {
          dia_semana: 1,
          dia: 'SEGUNDA-FEIRA',
          aberto: false,
          abertura: null,
          fechamento: null
        },
        {
          dia_semana: 2,
          dia: 'TERÇA-FEIRA',
          aberto: false,
          abertura: null,
          fechamento: null
        },
        {
          dia_semana: 3,
          dia: 'QUARTA-FEIRA',
          aberto: false,
          abertura: null,
          fechamento: null
        },
        {
          dia_semana: 4,
          dia: 'QUINTA-FEIRA',
          aberto: false,
          abertura: null,
          fechamento: null
        },
        {
          dia_semana: 5,
          dia: 'SEXTA-FEIRA',
          aberto: false,
          abertura: null,
          fechamento: null
        },
        {
          dia_semana: 6,
          dia: 'SÁBADO',
          aberto: false,
          abertura: null,
          fechamento: null
        },
      )
    }


  }

  limparHorarios() {
    this.horario_salvo = false
    this.array_horario_funcionamento_selecionado = []
    this.array_horario_funcionamento = []
    this.array_horario_funcionamento.push({
      dia_semana: 0,
      dia: 'DOMINGO',
      aberto: false,
      abertura: null,
      fechamento: null
    },
      {
        dia_semana: 1,
        dia: 'SEGUNDA-FEIRA',
        aberto: false,
        abertura: null,
        fechamento: null
      },
      {
        dia_semana: 2,
        dia: 'TERÇA-FEIRA',
        aberto: false,
        abertura: null,
        fechamento: null
      },
      {
        dia_semana: 3,
        dia: 'QUARTA-FEIRA',
        aberto: false,
        abertura: null,
        fechamento: null
      },
      {
        dia_semana: 4,
        dia: 'QUINTA-FEIRA',
        aberto: false,
        abertura: null,
        fechamento: null
      },
      {
        dia_semana: 5,
        dia: 'SEXTA-FEIRA',
        aberto: false,
        abertura: null,
        fechamento: null
      },
      {
        dia_semana: 6,
        dia: 'SÁBADO',
        aberto: false,
        abertura: null,
        fechamento: null
      },



    )
    this.horario_limpo = true
  }

  saveHorario() {
    this.array_horario_funcionamento_selecionado = this.array_horario_funcionamento
    this.horario_limpo = false
    this.horario_salvo = true
  }

  addDiretoria() {
    let y = this.form.get('diretoria.presidente').value
    let z = this.form.get('diretoria.pessoa_id').value
    let presidente

    if (y == true) {
      presidente = 'Sim';
    } else {
      presidente = 'Não';
    }


    this.array_diretoria.push(
      {
        pessoa_id: z,
        presidente: presidente,
      }
    )
    this.form.get('diretoria').reset()
    this.verificaPresidente()
  }

  filtrarPessoas(event: any) {
    // let query = event.query;
    // if (query.length > 2) {
    //   this._pessoa.autoCompletePessoa(query).subscribe((json) => {
    //     this.pessoasFiltradas = [];
    //     json.map((item) => {
    //       this.pessoasFiltradas = [
    //         ...this.pessoasFiltradas,
    //         { value: item.id, label: item.nome },
    //       ];
    //     });
    //   });
    // }
  }

  addContato() {

    this.form.get('pessoa_contato').validator

    let y = this.form.get('pessoa_contato.principal').value
    let z = this.form.get('pessoa_contato.tipo_contato_id').value
    let c = this.dropDownTipoContato.filter(x => { return x.value == z });
    let tipo = (c[0].label)
    let contato_principal

    if (y == true) {
      contato_principal = 'Sim';
    } else {
      contato_principal = 'Não';
    }


    this.array_contatos.push(
      {
        tipo_contato_id: z,
        principal: y,
        tipo_contato: tipo,
        contato: this.form.get('pessoa_contato.contato').value,
        campo_principal: contato_principal
      }
    )
    this.form.get('pessoa_contato').reset()
    // this.verificaContatoPrincipal()
  }

  addDesconto() {
    let _descricao = this.form.get('desconto_empresa.descricao').value
    let _tipDesconto: number = parseInt(this.form.get('desconto_empresa.tipo_desconto').value)
    let _descricaoTipoDesconto = this.dropDownTipDesconto[_tipDesconto].label
    let _valor = this.form.get('desconto_empresa.valor').value


    this.array_desconto.push(
      {
        descricao: _descricao,
        tipo_desconto: _tipDesconto,
        descricao_tipo_desconto: _descricaoTipoDesconto,
        valor: _valor
      }
    )
    this.form.get('desconto_empresa').reset()
  }


  removeDesconto(desconto: any) {
    let arr = this.array_desconto.filter(x => { return x !== desconto });

    this.array_desconto = []

    this.array_desconto = arr;
    // this.verificaContatoPrincipal()
  }


  removeContato(contato: any) {
    let arr = this.array_contatos.filter(x => { return x.contato !== contato.contato });

    this.array_contatos = []

    this.array_contatos = arr;
    // this.verificaContatoPrincipal()
  }

  addQuadroSocietario() {
    if (this.form.get('quadro_societario.percentual').value > this.maximo_percentual) {
      this.form.get('quadro_societario.percentual').setValue(this.maximo_percentual)
    }

    let admin = this.form.get('quadro_societario.administrador').value
    let pessoa = this.form.get('quadro_societario.pessoa_id').value
    let administrador

    if (admin == true) {
      administrador = 'Sim';
    } else {
      administrador = 'Não';
    }

    this.array_quadro_societario.push(
      {
        pessoa_id: pessoa.value,
        socio: pessoa.label,
        administrador: administrador,
        socio_administrador: admin,
        percentual: this.form.get('quadro_societario.percentual').value,

      }
    )
    this.form.get('quadro_societario').reset()
    this.verificaQuadroSocietario()
  }

  addEndereco() {
    // let y = this.form.get('pessoa_endereco.principal').value
    // let endereco_principal

    // if (y == true) {
    //   endereco_principal = 'Sim';
    // } else {
    //   endereco_principal = 'Não';
    // }
    this.array_enderecos.push(
      {
        cep: this.form.get('pessoa_endereco.cep').value,
        // principal: y,
        // endereco_principal: endereco_principal,
        logradouro: this.form.get('pessoa_endereco.logradouro').value,
        complemento: this.form.get('pessoa_endereco.complemento').value,
        numero: this.form.get('pessoa_endereco.numero').value,
        bairro: this.form.get('pessoa_endereco.bairro').value,
        municipio: this.form.get('pessoa_endereco.municipio').value,
        uf: this.form.get('pessoa_endereco.uf').value,
      }
    )
    this.form.get('pessoa_endereco').reset()
    // this.verificaEnderecoPrincipal()
  }

  // verificaEnderecoPrincipal() {
  //   let p = this.array_enderecos.find(element => element.endereco_principal == 'Sim')

  //   if (p == undefined) {
  //     this.existe_endereco_principal = false
  //   } else {
  //     this.existe_endereco_principal = true
  //   }

  // }

  removeEndereco(endereco: any) {
    if (endereco.id != null && endereco.id !== undefined) {
      this.pessoa_endereco_excluir_ids.push(Number(endereco.id));
    }
    const arr = this.array_enderecos.filter(x =>
      x.id != null && endereco.id != null ? x.id !== endereco.id : x !== endereco
    );
    this.array_enderecos = [];
    this.array_enderecos = arr;
  }


  getCEP() {
    this.processando = true;
    let cep = this.form.get("pessoa_endereco.cep").value;
    cep = parseInt(cep.replace(/[^0-9]/g, ""));

    if (cep == null) {
      return;
    }


    this.http
      .get(`https://viacep.com.br/ws/${cep}/json`)
      .toPromise()
      .then(
        (result) => {
          this.form.get('pessoa_endereco.bairro').setValue(result["bairro"]);
          this.form.get('pessoa_endereco.complemento').setValue(result["complemento"])
          this.form.get('pessoa_endereco.logradouro').setValue(result["logradouro"])
          this.form.get('pessoa_endereco.municipio').setValue(result["localidade"])
          this.form.get('pessoa_endereco.uf').setValue(result["uf"])
          this.processando = false
        },
        (err) => {
          this.processando = false;
          this.messageService.add({
            severity: "warn",
            summary: "Erro",
            detail: "Ocorreu um erro. Tente novamente!",
          });
        }
      );
  }

  fileInput(event: any) {
    this.images = event.files;
  }


  inputGallery(event: any) {
    const input = event.target as HTMLInputElement;
    let files: any = input.files;
    this.showGallery(files);
  }

  showGallery(files: any) {

    let window = this;
    [...files].forEach(file => {
      let formData: FormData = new FormData();

      formData.append('files[]', file);

      let url: any;
      var reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (_event) => {
        url = reader.result;

        this.resizeImage(url, { width: 250 }).then(function (blob: any) {

          var reader2 = new FileReader();
          reader2.readAsDataURL(blob);
          reader2.onload = (_event) => {
            window.images.push({
              file: file,
              url: reader2.result,
              caption: null,
              tipo_arquivo: null,
            })
          }
        })

      }
      this.files = files
    });


  }

  resizeImage(src: any, options: any) {

    return this.loadImage(document.createElement('img'), src).then(function (image: any) {

      var canvas = document.createElement('canvas');

      if (options.width && !options.height) {
        options.height = image.height * (options.width / image.width)
      } else if (!options.width && options.height) {
        options.width = image.width * (options.height / image.height)
      }

      Object.assign(canvas, options);

      canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height);

      return new Promise(function (resolve) {
        canvas.toBlob(resolve, options.type || 'image/png', options.quality)
      })
    })
  }

  loadImage(img: any, src: any) {
    return new Promise((resolve, reject) => {
      img.src = src;
      img.completed ? resolve(img) : img.addEventListener('load', function () {
        resolve(img)
      });
      img.addEventListener('error', reject);
    })
  }

  removeImg(event: any) {
    let arr = this.images.filter((x) => {
      return x.url !== event.url;
    });

    this.images = [];

    this.images = arr;
  }

  
}
